import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight
import {
  Email,
  Password,
  People,
  Smartphone,
  Face6,
} from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import apilink from "../apiURL/baseUrls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

const SignUp = () => {
  const [family, setFamily] = useState("");
  const [alias, setAlias] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [passwordcon, setPasswordcon] = useState("");
  const [val, setVal] = useState(false); //initializes checkbox to false
  const [posting, setPosting] = useState(false);

  const Checkbox = (props) => {
    return (
      <input
        type="checkbox"
        style={{
          color: "#ddd",
          alignItems: "center",
          justifyContent: "left",
          width: "20px",
          height: "20px",
          gap: "4px",
        }}
        checked={props.val}
        onChange={() => {
          props.setValue(!props.val);
        }}
      />
    );
  };
  const navigate = useNavigate();

  const handleSignUp = async () => {
    if (family === "") {
      toast.warn("Failed. Fill in the family name", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (alias === "") {
      toast.warn("Failed. Fill in your name", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (email === "") {
      toast.warn("Failed. Fill in your email", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (phone === "") {
      toast.warn("Failed. Fill in your phone number", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (password === "") {
      toast.warn("Failed. Fill in your password", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (password !== passwordcon) {
      toast.warn("Failed. Confirm password correctly", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (posting === true) {
      return;
    }

    setPosting(true);
    const dataObj = {
      family,
      alias,
      phone,
      email,
      password,
    };

    const baseUrl = apilink.link;
    axios
      .post(`${baseUrl}/family/signup`, dataObj)
      .then((response) => {
        if (response.data.message === "Family registration successfull") {
          setPosting(false);
          setFamily("");
          setAlias("");
          setEmail("");
          setPhone("");
          setPassword("");
          setPasswordcon("");
          setVal(false); 
          toast.success("Family registration successfull. Check email for further instructions", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        } else {
          setPosting(false);
          toast.warn(response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          return;
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("Error creating post");
      });

    //navigate("/admin");
  };

  const handleMemberSignIn = () => {
    navigate("/");
  };

  return (
    <>
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "76px",
          paddingInline: 30,
        }}
      >
        <img
          alt="logo"
          style={{ width: "100px", height: "80px", resizeMode: "stretch" }}
          src={require("./pic1.webp")}
        />
        <h1
          className="navbar-brand mb-0"
          style={{ fontFamily: "Caveat", fontSize: 20 }}
        >
          family<b>Tree</b>
        </h1>
        <p
          style={{
            color: "#EA6C82",
            fontFamily: "Open Sans",
            marginTop: "40px",
          }}
        >
          Account Sign Up
        </p>
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#EA6C82",
            backgroundColor: "#EA6C82",
            borderRadius: 5,
            height: 50,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              width: "40px",
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <People style={{ color: "#ffffff" }} />
          </div>
          <div
            style={{
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              style={{
                height: 48.2,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: "none",
              }}
              value={family}
              maxLength={20}
              placeholder="Family name"
              onChange={(e) => {
                setFamily(e.target.value);
              }}
            />
          </div>
          <div></div>
        </div>
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#EA6C82",
            backgroundColor: "#EA6C82",
            borderRadius: 5,
            height: 50,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              width: "40px",
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Face6 style={{ color: "#ffffff" }} />
          </div>
          <div
            style={{
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              style={{
                height: 48.7,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: "none",
              }}
              value={alias}
              placeholder="Full name"
              maxLength={30}
              onChange={(e) => {
                setAlias(e.target.value);
              }}
            />
          </div>
          <div></div>
        </div>
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#EA6C82",
            backgroundColor: "#EA6C82",
            borderRadius: 5,
            height: 50,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              width: "40px",
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Email style={{ color: "#ffffff" }} />
          </div>
          <div
            style={{
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              style={{
                height: 48.7,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: "none",
              }}
              value={email}
              placeholder="Email address [Valid and working]"
              maxLength={30}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </div>
          <div></div>
        </div>
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#EA6C82",
            backgroundColor: "#EA6C82",
            borderRadius: 5,
            height: 50,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              width: "40px",
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Smartphone style={{ color: "#ffffff" }} />
          </div>
          <div
            style={{
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              style={{
                height: 48.7,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: "none",
              }}
              value={phone}
              placeholder="Mobile number [Valid and working]"
              maxLength={30}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
            />
          </div>
          <div></div>
        </div>
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#EA6C82",
            backgroundColor: "#EA6C82",
            borderRadius: 5,
            height: 50,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              width: "40px",
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Password style={{ color: "#ffffff" }} />
          </div>
          <div
            style={{
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              style={{
                height: 48.8,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: "none",
              }}
              value={password}
              placeholder="Password"
              type="password"
              maxLength={20}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </div>
          <div></div>
        </div>
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#EA6C82",
            backgroundColor: "#EA6C82",
            borderRadius: 5,
            height: 50,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              width: "40px",
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Password style={{ color: "#ffffff" }} />
          </div>
          <div
            style={{
              height: 50,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <input
              style={{
                height: 48.8,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: "none",
              }}
              value={passwordcon}
              placeholder="Confirm Password"
              type="password"
              maxLength={20}
              onChange={(e) => {
                setPasswordcon(e.target.value);
              }}
            />
          </div>
          <div></div>
        </div>
        <p
          style={{
            color: "#000000",
            fontFamily: "Open Sans",
            fontSize: 14,
            marginTop: "30px",
            alignSelf: "left",
            width: "320px",
          }}
        >
          <Checkbox value={val} setValue={setVal}></Checkbox>
          &nbsp;&nbsp;Agree to{" "}
          <span style={{ color: "#EA6C82" }}>Terms and conditions</span>
        </p>
        <button
          onClick={() => handleSignUp()}
          style={{
            width: "320px",
            backgroundColor: "#EA6C82",
            borderRadius: 5,
            border: "none",
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 14,
            color: "white",
            marginTop: "10px",
          }}
        >
          {posting === false && <>Proceed</>}
          {posting && (
            <>
              <Squares />
            </>
          )}
        </button>

        <p
          onClick={() => handleMemberSignIn()}
          style={{
            color: "#000000",
            fontFamily: "Open Sans",
            fontSize: 14,
            marginTop: "20px",
            alignSelf: "left",
            width: "320px",
          }}
        >
          Family member <span style={{ color: "#EA6C82" }}>Sign In</span>
        </p>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </>
  );
};

export default SignUp;
